import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { DeleteEventCategoryDialog } from '../../../features/event-categories/components/delete-event-category-dialog';
import { EventCategoryForm } from '../../../features/event-categories/components/event-category-form';
import { eventCategoryByIdOptions } from '../../../features/event-categories/queries';
import { PageHeader } from '../../../shared/components/page-header';
import { SuperadminCatalogNotice } from '../../../shared/components/superadmin-catalog-notice';

export const Route = createFileRoute('/_authenticated/event-categories/$categoryId')({
  staticData: { breadcrumb: 'Редактирование' },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(eventCategoryByIdOptions(params.categoryId)),
  component: EditEventCategoryPage,
});

function EditEventCategoryPage() {
  const router = useRouter();
  const { categoryId } = Route.useParams();
  const { data: category } = useSuspenseQuery(eventCategoryByIdOptions(categoryId));
  const { adminRoles } = useAuth();
  const canEdit = canEditGlobalCatalog(adminRoles);

  return (
    <div>
      {!canEdit && <SuperadminCatalogNotice />}
      <PageHeader
        title={category.name}
        description={`slug: ${category.slug}`}
        actions={
          canEdit ? (
            <DeleteEventCategoryDialog
              category={category}
              onDeleted={() => router.navigate({ to: '/event-categories' })}
            />
          ) : null
        }
      />
      <EventCategoryForm mode="edit" category={category} readOnly={!canEdit} />
    </div>
  );
}
